import { introScene } from "./introScene";
import { mainScene } from "./mainScene";
import { outroScene } from "./outroScene";

introScene.thenScene(mainScene).thenScene(outroScene);

export { introScene as timeline };
